import { ICustomFilterProps } from 'react-bootstrap-table2-filter';
import { TextFilterRenderer } from './TextFilter';
import { NumberFilterRenderer } from './NumberFilter';
import { DateRangeFilterRenderer } from './DateRangeFilter';
import { SelectFilterRenderer } from './SelectFilter';

export const FilterRendererFactory = <T extends object = {}>(filter: { props: ICustomFilterProps }) => {
  switch (filter.props.type) {
    case 'TEXT':
      return TextFilterRenderer<T>(filter.props);
    case 'NUMBER':
      return NumberFilterRenderer<T>(filter.props);
    case 'DATERANGE':
      return DateRangeFilterRenderer<T>(filter.props);
    case 'SELECT':
      return SelectFilterRenderer<T>(filter.props);
    case 'BUTTON':
    case 'MULTISELECT':
    default:
      return () => `${filter.props.type} Not Implemented`;
  }
};
